var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeSeriesCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76 14L9 10.76L12.24 14L13.5 12.74L10.26 9.5L13.5 6.26L12.24 5L9 8.24L5.76 5L4.5 6.26L7.74 9.5L4.5 12.74L5.76 14ZM9 18.5C7.755 18.5 6.585 18.2638 5.49 17.7912C4.395 17.3187 3.4425 16.6775 2.6325 15.8675C1.8225 15.0575 1.18125 14.105 0.70875 13.01C0.23625 11.915 0 10.745 0 9.5C0 8.255 0.23625 7.085 0.70875 5.99C1.18125 4.895 1.8225 3.9425 2.6325 3.1325C3.4425 2.3225 4.395 1.68125 5.49 1.20875C6.585 0.73625 7.755 0.5 9 0.5C10.245 0.5 11.415 0.73625 12.51 1.20875C13.605 1.68125 14.5575 2.3225 15.3675 3.1325C16.1775 3.9425 16.8187 4.895 17.2912 5.99C17.7638 7.085 18 8.255 18 9.5C18 10.745 17.7638 11.915 17.2912 13.01C16.8187 14.105 16.1775 15.0575 15.3675 15.8675C14.5575 16.6775 13.605 17.3187 12.51 17.7912C11.415 18.2638 10.245 18.5 9 18.5ZM9 16.7C11.01 16.7 12.7125 16.0025 14.1075 14.6075C15.5025 13.2125 16.2 11.51 16.2 9.5C16.2 7.49 15.5025 5.7875 14.1075 4.3925C12.7125 2.9975 11.01 2.3 9 2.3C6.99 2.3 5.2875 2.9975 3.8925 4.3925C2.4975 5.7875 1.8 7.49 1.8 9.5C1.8 11.51 2.4975 13.2125 3.8925 14.6075C5.2875 16.0025 6.99 16.7 9 16.7Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSeriesCloseIcon);
export default __webpack_public_path__ + "static/media/TimeSeriesClose_icon.418fb44d926c0efb429eecb5803d6e8b.svg";
export { ForwardRef as ReactComponent };